import { render, staticRenderFns } from "./WebsiteUrlBlockAlert.vue?vue&type=template&id=516ce076&scoped=true&"
import script from "./WebsiteUrlBlockAlert.vue?vue&type=script&lang=js&"
export * from "./WebsiteUrlBlockAlert.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteUrlBlockAlert.vue?vue&type=style&index=0&id=516ce076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516ce076",
  null
  
)

export default component.exports